import React from 'react';
import { App } from '@/types/App';
import { ChevronRight } from 'lucide-react';

interface AppCardProps {
  app: App;
  onAppSelect: (app: App) => void;
}

const AppCard: React.FC<AppCardProps> = ({ app, onAppSelect }) => {
  const handleCardClick = () => {
    onAppSelect(app);
  };

  return (
    <button 
      className="w-full text-left active:bg-muted/70 hover:bg-muted/50 transition-colors duration-150 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
      onClick={handleCardClick}
    >
      <div className="px-4 py-3 flex items-center gap-4">
        <div className="flex-shrink-0">
          <img
            src={app.icon}
            alt={`${app.name} icon`}
            className="w-14 h-14 rounded-xl object-cover bg-muted shadow-sm"
            loading="lazy"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-medium text-foreground truncate leading-snug">
            {app.name}
          </h3>
          {app.category && (
            <p className="text-sm text-muted-foreground mt-0.5 truncate">
              {app.category}
            </p>
          )}
        </div>
        <div className="flex-shrink-0 pl-2">
          <ChevronRight className="w-5 h-5 text-muted-foreground/60" />
        </div>
      </div>
    </button>
  );
};

export default AppCard;
